import {Appliance} from './appliance';

export interface Area {
    number: number,
    label: string,
    assumptions: string[],
    qty: number,
    appliances: Appliance[],
    usage: number,
    storage: number
}
